export default "__VITE_ASSET__BmSlR2ov__"